import PaymentCardView from './PaymentCardView';

export default PaymentCardView; 